module.exports = __webpack_public_path__ + "img/banner-8.00d50dd1.jpg";